import React, { useState, useCallback, useEffect } from "react";
import {
  Modal,
  Button,
  TextContent,
  Text,
  TextVariants,
  TextInput,
} from "@patternfly/react-core";
import _capitalize from "lodash/capitalize";

import { REQUESTED_DELETE_PRODUCT } from "../../redux/actions/productAction";
import { REQUESTED_DELETE_VERSION } from "../../redux/actions/versionAction";
import { REQUESTED_DELETE_VERSION_PHASE } from "../../redux/actions/phaseAction";
import {
  REQUESTED_PRODUCT_SUITES,
  REQUESTED_DELETE_PRODUCT_SUITE,
} from "../../redux/actions/productSuiteAction";
import {
  REQUESTED_PRODUCT_GROUPS,
  REQUESTED_DELETE_PRODUCT_GROUP,
} from "../../redux/actions/productGroupAction";
import {
  REQUESTED_USERS,
  REQUESTED_DELETE_USER,
} from "../../redux/actions/userAction";
// import { REQUESTED_ACTIVITIES } from "../../redux/actions/activityAction";
import { useDispatch, useMappedState } from "redux-react-hook";

export default (props) => {
  const { isModalOpen, handleModalToggle } = props;

  const mapState = useCallback(
    (state) => ({
      isDeletedUser: state.userState.isDeletedUser,
      isDeletedProductSuite: state.productSuiteState.isDeletedProductSuite,
      isDeletedProductGroup: state.productGroupState.isDeletedProductGroup,
    }),
    []
  );

  const {
    isDeletedUser,
    isDeletedProductSuite,
    isDeletedProductGroup,
  } = useMappedState(mapState);

  const [inputValue, setInputValue] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);

  function handleTextInputChange(inputValue) {
    setInputValue(inputValue);
    if (inputValue === props.name) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }

  const dispatch = useDispatch();

  function handleRemove() {
    switch (props.type) {
      case "product":
        dispatch({
          type: REQUESTED_DELETE_PRODUCT,
          payload: { product: { id: props.productId } },
        });
        break;
      case "version":
        dispatch({
          type: REQUESTED_DELETE_VERSION,
          payload: { version: { id: props.versionId } },
        });
        break;
      case "phase":
        dispatch({
          type: REQUESTED_DELETE_VERSION_PHASE,
          payload: { phase: { id: props.phaseId } },
        });
        break;
      case "product suite":
        dispatch({
          type: REQUESTED_DELETE_PRODUCT_SUITE,
          payload: { productSuite: { id: props.productSuiteId } },
        });
        break;
      case "product group":
        dispatch({
          type: REQUESTED_DELETE_PRODUCT_GROUP,
          payload: { productGroup: { id: props.productGroupId } },
        });
        break;
      case "user":
        dispatch({
          type: REQUESTED_DELETE_USER,
          payload: { user: { id: props.userid } },
        });
        break;
      default:
        console.log(`the prop type is ${props.type}`);
    }

    handleModalToggle();
  }

  useEffect(() => {
    if (isDeletedUser) {
      dispatch({
        type: REQUESTED_USERS,
        payload: {},
      });
    }
    if (isDeletedProductSuite) {
      dispatch({
        type: REQUESTED_PRODUCT_SUITES,
        payload: {},
      });
    }
    // dispatch({
    //   type: REQUESTED_ACTIVITIES,
    //   payload: {},
    // });
  }, [dispatch, isDeletedUser, isDeletedProductSuite]);

  return (
    <Modal
      width={"50%"}
      title="Confirmation Required"
      isOpen={isModalOpen}
      onClose={handleModalToggle}
      actions={[
        <Button
          isDisabled={isDisabled}
          key="Remove"
          variant="danger"
          onClick={handleRemove}
        >
          Remove
        </Button>,
        <Button key="Cancel" variant="secondary" onClick={handleModalToggle}>
          Cancel
        </Button>,
      ]}
    >
      <TextContent>
        <Text component={TextVariants.p}>
          You are going to remove {props.type} <strong>{props.name}</strong>.
          Removed {props.type} CANNOT be restored! Are you ABSOLUTELY sure?
        </Text>
        <Text component={TextVariants.p}>
          This action can lead to data loss. To prevent accidental actions we
          ask you to confirm your intention. Please type the name of the{" "}
          {props.type} to proceed or close this modal to cancel.
        </Text>
        <Text component={TextVariants.p}>
          {_capitalize(props.type)} Name
          <TextInput
            value={inputValue}
            type="text"
            onChange={handleTextInputChange}
            aria-label={`${props.type} name input`}
          />
        </Text>
      </TextContent>
    </Modal>
  );
};
